import { Link } from 'react-router';
import { Box, CustomSpinner, Row, Text } from '~/commonComponents';
import { useGetJobPostDetail } from '~/domain/PermanentJobs';

interface IJobTitleInfoProps {
  jobPostingId?: string;
}

export const JobTitleInfo = ({ jobPostingId }: IJobTitleInfoProps) => {
  const { data, isLoading } = useGetJobPostDetail(jobPostingId);

  return (
    <Row className="row_style">
      <Text bold margin={0}>
        Job Title:
      </Text>
      <Box alignItems="center" justifyContent="flex-end">
        {isLoading ? (
          <CustomSpinner isLoading size={12} />
        ) : (
          <>
            {data?.title ? (
              <Link to={`/permanent-jobs/job-overview/${data?.id}`}>
                <Text fontSize={18} textDecoration="underline">
                  {data?.title}
                </Text>
              </Link>
            ) : (
              '-'
            )}
          </>
        )}
      </Box>
    </Row>
  );
};
